module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Attendance-Leaves/time-roll-approval/time-roll-apprve-grid/time-roll-apprve-grid.component.css
// module id = ./src/app/hrms/Attendance-Leaves/time-roll-approval/time-roll-apprve-grid/time-roll-apprve-grid.component.css
// module chunks = main